define.alias("shared/components/shared/post/secondary/hashtag-suggestions/error", "settings/components/shared/post/secondary/hashtag-suggestions/error");